document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-custom-tabs]').forEach((tabsRoot) => {
    if (tabsRoot.dataset.tabsInitialized === 'true') return;
    tabsRoot.dataset.tabsInitialized = 'true';

    const buttons = tabsRoot.querySelectorAll('.custom-tab-button');
    const panels = tabsRoot.querySelectorAll('.custom-tab-panel');

    // Shared heading that reflects the active tab's label (used by legal-tabs).
    const titleEl = tabsRoot.querySelector('.legal-header-title');

    buttons.forEach((button) => {
      button.addEventListener('click', function () {
        const targetId = this.getAttribute('aria-controls');

        buttons.forEach((btn) => {
          btn.classList.remove('active');
          btn.setAttribute('aria-selected', 'false');
        });

        panels.forEach((panel) => {
          panel.classList.remove('active');
        });

        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');

        const targetPanel = tabsRoot.querySelector('#' + targetId);
        if (targetPanel) targetPanel.classList.add('active');

        if (titleEl && this.textContent.trim()) {
          titleEl.textContent = this.textContent.trim();
        }
      });
    });

    // Activate the tab that matches a URL hash (used on load and on same-page hash changes)
    const activateTabFromHash = () => {
      const hash = window.location.hash;
      if (!hash) return;
      const cleanHash = hash.replace('#', '');
      const matchingButton = Array.from(buttons).find(btn => {
        const controls = btn.getAttribute('aria-controls') || '';
        return controls === cleanHash || controls === 'legal-' + cleanHash;
      });
      if (matchingButton) {
        matchingButton.click();
        // Smooth scroll to tabs section after a slight delay
        setTimeout(() => {
          tabsRoot.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    };

    // Auto-activate tab from URL hash on load
    activateTabFromHash();

    // Handle same-page hash navigation (e.g. clicking a policy link in the footer
    // while already on the legal page) without a full page reload.
    window.addEventListener('hashchange', activateTabFromHash);
  });
});
